module.exports = __webpack_public_path__ + "static/architecture.1d240476.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/laminardata/architecture.png
// module id = 1160
// module chunks = 112875127094159